import { isString } from "@mcwd/typescript-type-guards";
import { type SocialMediaName, getSocialMediaName } from "./getSocialMediaName.js";
import { isPrDomain } from "./isPrDomain.js";
import { isTopFiveSearchEngine } from "./isTopFiveSearchEngine.js";
import { ComputedValueGetter } from "../../../../utils/ComputedValueGetter.js";
import { ExternalReferrerValueGetter } from "../getExternalReferrer.js";
import { getCookie } from "../../../../utils/cookieUtils.js";
export type ExternalReferrerMetaDataType =
  | { type: "direct"; }
  | { type: "top-5-search"; }
  | { type: "pr-domain"; }
  | { type: "social-media"; name: SocialMediaName; }
  | { type: "referral"; }
  ;

export function getExternalReferrerMetaData (externalReferrer: string): ExternalReferrerMetaDataType
{
  if (externalReferrer === "") {
    return { type: "direct" };
  }
  if (isTopFiveSearchEngine(externalReferrer)) {
    return { type: "top-5-search" };
  }
  if (isPrDomain(externalReferrer)) {
    return { type: "pr-domain" };
  }
  const socialMediaName = getSocialMediaName(externalReferrer);
  if (isString(socialMediaName)) {
    return { type: "social-media", name: socialMediaName };
  }
  return { type: "referral" };
}

export const ExternalReferrerMetaData = new ComputedValueGetter({
  isLazy: true,
  computeFn: () => {
    //check cookie fist
    const source_string = getCookie("source_string");
    if (source_string) {
      const domain = new URL(source_string).origin;
      return getExternalReferrerMetaData(domain);
    }
    // if not cookie exists than check the referrer 
    return getExternalReferrerMetaData(ExternalReferrerValueGetter.value);
  }
});
